import { render } from "./LegsStops.vue?vue&type=template&id=e8d04c04&scoped=true&lang=pug"
import script from "./LegsStops.vue?vue&type=script&lang=ts"
export * from "./LegsStops.vue?vue&type=script&lang=ts"

import "./LegsStops.vue?vue&type=style&index=0&id=e8d04c04&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e8d04c04"

export default script